import React from "react";
import { useSelector } from 'react-redux';
import { Box, Text, Center, SimpleGrid, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const BrandkitColorPaletteGrid = (props) => {
  const selectedBrandkit = useSelector((state) => state.brandKit.selectedBrandkit);
  const { palette } = selectedBrandkit;
  const editor = useSelector((state) => state.editor);

  const { t } = useTranslation(["planner"]);

  const { header } = props;

  return (
    <Box mb={3}>
      {header}

      {palette.length > 0 && palette[0] ? (
        <>
          {palette[0].colors && palette[0].colors.length > 0 ? (
            <SimpleGrid columns={5} spacing={4}>
              {palette[0].colors.map((color, index) => (
                <Tooltip key={index} label={color.rgb} hasArrow placement="bottom">
                  <Box
                    bg={color.rgb}
                    h="54px"
                    w="54px"
                    borderRadius="8px"
                    onClick={() => handleOnColorClick(color)}
                    _hover={{
                      cursor: "pointer"
                    }}
                  />
                </Tooltip>
              ))}
            </SimpleGrid>
          ) : null}
        </>
      ) : (
        <Center>
          <Text
            color="gray.300"
            fontSize="1rem"
          >
              {t("brandkit.no_color_palettes_message")}
          </Text>
        </Center>
      )}
    </Box>
  );

  function handleOnColorClick({ rgb }) {
    const { canvasRef } = props;
    const { activePage, activeElement, activeSelection } = editor;

    if (activeSelection.mime === "selection") {
      return;
    } else if (activePage.isSelected) {
      canvasRef.handler.workareaHandler.backgroundColor(rgb);
      return;
    } else {
      if (activeElement.mime === "text") {
        canvasRef.handler.textHandler.textColor(rgb);
      }
    }
  };
};

export default BrandkitColorPaletteGrid;